











































































































































































































































































































































































































































































































































































export default {
  name: "BasePositionCheckbox",
  data: function () {
    return { hoveredPosition: "" };
  },
  props: {
    positions: {
      type: Object,
    },
    overlay: {
      type: Object,
    },
    isParentHover: {
      type: Boolean,
    },
  },
  methods: {
    clickPosition: function (positionName) {
      this.$emit("clickPosition", this.overlay, positionName);
    },

    isCurrentPosition(positionName) {
      return this.overlay.position === positionName;
    },

    isHoverCurrentPosition(positionName) {
      return this.hoveredPosition === positionName;
    },

    onMouseOverOverlayPosition(positionName) {
      this.hoveredPosition = positionName;
    },

    onMouseLeaveOverlayPosition() {
      this.hoveredPosition = "";
    },
  },
};
